import React from 'react';
import ReactDOM from 'react-dom';
import Relay from 'common/oldJavascripts/utils/react/Relay.js';
import collection from 'common/oldJavascripts/utils/collection.js';
import BoxBody from 'common/oldJavascripts/components/Base/Box/BoxBody';
import BoxItem from 'common/oldJavascripts/components/Base/Box/BoxItem';
import Loader from 'common/components/Loader';
import Fields from './Documents/Fields';
import UsersAndDepartments from './Documents/UsersAndDepartments';
import Details from './Documents/Details';
import history from 'common/constants/config/history';
import ValidationAlert from 'common/oldJavascripts/components/Base/ValidationAlert';
import ProjectStatus from 'common/components/ProjectStatus';
import ProjectClone from 'common/components/ProjectClone';
import Feature from 'common/components/Feature';

import { Grid } from '@material-ui/core';

const VALIDATION_FIELD_NAME_OVERRIDES = {
  box_rental_per: 'Box Rental per day/week',
  computer_rental_per: 'Computer Rental per day/week',
  car_allowance_per: 'Car Allowance per day/week',
  mobile_phone_per: 'Mobile Phone Allowance per day/week',
  per_diem_allowance_per: 'Per Diem Allowance per day/week',
  housing_allowance_per: 'Housing Allowance per day/week',
  weekly_rate_days: 'Weekly Rate and Days per day/week',
};

export default Relay.createClass({
  statics: {
    mutators: {
      projectDetails: {
        info: function(_, related) {
          var routerParams = related['/router/params'];

          return {
            id: '/projects/' + routerParams.projectId + '/details',
          };
        },
      },

      projectEnforceMask: {
        info: function(_, related) {
          const routerParams = related['/router/params'];

          return {
            id: `/projects/${routerParams.projectId}/enforce-mask`,
            create: true,
          };
        },
      },
    },

    queries: {
      nonEmployees: {
        info: function(_, related) {
          var routerParams = related['/router/params'];

          return {
            id: '/projects/' + routerParams.projectId + '/non-employees',
          };
        },
      },

      customFields: {
        info: function(_, related) {
          var params = related['/router/params'];

          return {
            id: '/projects/' + params.projectId + '/custom-fields',
          };
        },
      },

      states: {
        info: function(_, related) {
          var params = related['/router/params'];

          return {
            id: '/projects/' + params.projectId + '/states',
          };
        },
      },
      project: {
        info: function(_, related) {
          var params = related['/router/params'];

          return {
            id: '/projects/' + params.projectId,

            cursor: {
              with_privileges: true,
            },
          };
        },
      },
    },
  },

  componentWillReceiveProps(nextProps) {
    const { project } = nextProps;
    const { detailSubDataType } = this.state;
    if (project.status === 'success' && !detailSubDataType) {
      this.setState({ detailSubDataType: project.data.data_type });
    }
  },

  getInitialState() {
    return { detailSubDataType: null };
  },

  updateDetailSubDataType(dataType) {
    this.setState({ detailSubDataType: dataType });
  },

  updateEnforceMask(value) {
    const {
      projectEnforceMask: enforceMaskMutator,
      project: projectMutator,
    } = this.props;

    enforceMaskMutator.updateAndSave(
      {
        enforce_mask: value,
      },
      '',
      { json: true },
      () => {
        projectMutator.reload();
      },
    );
  },

  _scrollUpToError() {
    const errorBoxDomNode = ReactDOM.findDOMNode(this.errorBox);
    if (errorBoxDomNode) errorBoxDomNode.scrollIntoView();
  },

  render: function() {
    let {
      routerParams: { projectId } = {},
      customFields = {},
      nonEmployees = {},
      projectDetails = {},
      states: statesQuery = {},
      project = {},
    } = this.props;
    const { errors: projectDetailsErrors = {} } = projectDetails || {};
    let states = [];
    const { detailSubDataType } = this.state;

    // Top level object that will contain all errors for project settings
    const errorsToDisplay = { ...projectDetailsErrors };
    if (
      nonEmployees.status === 'loading' ||
      customFields.status === 'loading' ||
      statesQuery.status === 'loading'
    ) {
      return <Loader />;
    }

    nonEmployees = nonEmployees.data;
    customFields = customFields.data;

    const {
      data: {
        enforce_loan_out = false,
        enforce_mask = false,
        account_mask,
      } = {},
    } = project;

    states = collection.map(statesQuery.data.items, function(state) {
      return { label: state.name, value: state.id };
    });

    return (
      <BoxBody>
        {Object.keys(errorsToDisplay).length ? (
          <BoxItem ref={ref => (this.errorBox = ref)}>
            <ValidationAlert
              errors={errorsToDisplay}
              overrides={VALIDATION_FIELD_NAME_OVERRIDES}
            />
          </BoxItem>
        ) : null}
        <BoxItem divider={true}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <ProjectStatus project={project.data} />
            </Grid>
            <Feature name="projectClone">
              <Grid item xs={6} align="right">
                <ProjectClone project={project.data} />
              </Grid>
            </Feature>
          </Grid>
        </BoxItem>
        <Fields
          updateDetailSubDataType={this.updateDetailSubDataType}
          accountMask={account_mask}
          enforceMask={enforce_mask}
          updateEnforceMask={this.updateEnforceMask}
        />
        <UsersAndDepartments
          nonEmployees={nonEmployees}
          detailSubDataType={detailSubDataType}
          projectId={projectId}
          enforceLoanOut={enforce_loan_out}
          enforceMask={enforce_mask}
          accountMask={account_mask}
        />
        <Details
          project={projectDetails}
          states={states}
          onCancel={this._cancel}
          onChangeReimbursements={this._changeReimbursements}
          onSaveFailure={this._scrollUpToError}
        />
      </BoxBody>
    );
  },

  _cancel: function() {
    const {
      projectDetails: projectDetailsMutator = {},
      routerParams: { projectId } = {},
    } = this.props;

    projectDetailsMutator.revert('hiring_status');
    projectDetailsMutator.revert('allow_end_date');
    projectDetailsMutator.revert('allow_hirers_to_send_offers');
    projectDetailsMutator.revert('send_final_docs_to_studio_plus');
    projectDetailsMutator.revert('send_provisional_deal_memo');
    projectDetailsMutator.revert('custom_email_text');

    history.push(`/projects/${projectId}/settings`);
  },

  _changeReimbursements: function(key, value) {
    const { projectDetails: projectDetailsMutator = {} } = this.props;
    projectDetailsMutator.update(key)(value);
  },
});
